const enabled = /unit|dev|itg/.test(typeof env === "object" ? env.platform : null) && !window.__karma__
// enabled if in itg, dev, or unit, and not karma

/**
 * Having a todo function in the code allows us to quickly find all references to easily
 * A good use case for using the todo function would be to mark code which is not
 * actively tested with notes. For example, when we notice that there is a block of code
 * in a line item details interface which may be affected by changes to the FuturePayment model
 * we are developing in Guest Payment, then we can mark the dead code with todo with notes
 * to come back to at a later date.
 *
 * @example
 * import { todo } from "./util/todo"
 * const nowValue = Date.now()
 * todo("Type this property", { nowValue }) // prints: TODO Type this property { nowValue: 1521734649837 }
 *
 * // If it is _not_ urgent to address your todo, just use a comment
 * // TODO: Refine this type
 *
 */
export const todo: (...notes) => void = enabled ? console.warn.bind(console, "%cTODO", "color: #f6b333") : function () { }
